import "$styles/index.css"
import "$styles/base/_forms.css"
import "$styles/base/_responsive.css"
import "$styles/pages/_contact.css"
import "$styles/pages/_portfolio.css"
import "$styles/pages/_solutions.css"
import "$styles/pages/_guide.css"
import "$styles/pages/_home.css"
import "$styles/pages/_pricing.css"
import "$styles/pages/_service.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

console.info("Bridgetown is loaded!")
